export default __webpack_public_path__ + "static/media/foto4.b6133a19.jpg";